import { useState, useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { TopBar } from './TopBar'

export function AdminLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false)

  // Prevent body scroll when the mobile drawer is open
  useEffect(() => {
    document.body.style.overflow = sidebarOpen ? 'hidden' : ''
    return () => { document.body.style.overflow = '' }
  }, [sidebarOpen])

  return (
    <div className="admin-shell">
      {/* Mobile backdrop — closes sidebar on tap */}
      {sidebarOpen && (
        <div
          className="sidebar-backdrop"
          onClick={() => setSidebarOpen(false)}
          aria-hidden="true"
        />
      )}

      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <div className="admin-main">
        <TopBar onMenuClick={() => setSidebarOpen((o) => !o)} />
        <main className="admin-content">
          <Outlet />
        </main>
      </div>

      <style>{`
        .admin-shell {
          display: flex;
          min-height: 100vh;
          background: var(--bg-primary);
        }
        .admin-main {
          flex: 1;
          margin-left: var(--sidebar-width);
          display: flex;
          flex-direction: column;
          min-height: 100vh;
          min-width: 0;
        }
        .admin-content {
          flex: 1;
          padding: 28px 32px;
          overflow-y: auto;
        }
        .sidebar-backdrop {
          display: none;
        }
        @media (max-width: 768px) {
          .admin-main { margin-left: 0; }
          .admin-content { padding: 20px 16px; }
          .sidebar-backdrop {
            display: block;
            position: fixed;
            inset: 0;
            background: rgba(0, 0, 0, 0.55);
            z-index: 25;
            animation: backdropFadeIn 0.2s ease;
          }
        }
        @keyframes backdropFadeIn {
          from { opacity: 0; }
          to   { opacity: 1; }
        }
      `}</style>
    </div>
  )
}
